const locals = {
  en: require('../locals/en.js'),
  ru: require('../locals/ru.js'),
  es: require('../locals/es.js'),
}

const processLang = Object.keys(locals).indexOf(process.env.LANG) > -1 ? process.env.LANG : 'en';
module.exports = locals[ processLang ];
